import React from "react";
import DatePicker from "react-datepicker";

export class CalgaryAssent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      agree_to_be_contacted: false,
      parent_name: "",
      parent_email: "",
      parent_phone_number: "",
      child_name: "",
      child_email: "",
      child_dob: "",
      delegate_name: "",
      witness_name: ""
    };
  }

  validateComplete = () => {
    const { child_name, child_email, child_dob } = this.state;

    let data = this.state;

    if (child_name && child_email && child_dob) {
      data.formValid = true;
    } else {
      data.formValid = false;
    }

    this.props.handleChange(data);
  };

  handleChange = event => {
    const { name, value } = event.target;
    if (
      [
        "parent_name",
        "parent_email",
        "parent_phone_number",
        "child_name",
        "child_email",
        "delegate_name",
        "witness_name"
      ].includes(name)
    ) {
      this.setState(
        {
          [name]: value
        },
        this.validateComplete
      );
    } else if (["agree_to_be_contacted"].includes(name)) {
      this.setState(
        {
          [name]: event.target.checked
        },
        this.validateComplete
      );
    }
  };

  handleDobChange = date => {
    this.setState({ child_dob: date }, this.validateComplete);
  };

  render() {
    const {
      child_name,
      child_email,
      child_dob,
      parent_name,
      parent_email,
      parent_phone_number,
      delegate_name,
      witness_name
    } = this.state;

    return (
      <div>
        <h4>Assent Form</h4>
        <h5 className="lead mt-3">TITLE:</h5>
        <b>
          Surveillance in High Schools to Reduce Concussions and Consequences of
          Concussions in Canadian Youth - SHRed Concussions
        </b>
        <h5 className="lead mt-3">FUNDING:</h5>
        National Football League's Scientific Advisory Board
        <h5 className="lead mt-3">INVESTIGATORS:</h5>
        <p>Principal Investigator: Dr. Carolyn Emery</p>
        <h5 className="lead mt-3">WHAT IS A RESEARCH STUDY?</h5>
        <p>
          A research study is a way to learn new information about something.
          Individuals do not need to be in a research study if they don't want
          to.
        </p>
        <h5 className="lead mt-3">
          WHY ARE YOU BEING ASKED TO BE PART OF THIS RESEARCH STUDY?
        </h5>
        <p>
          You are being asked to take part in this research study because we are
          trying to learn more about why some youth may be more likely to get a
          concussion, what affects the amount of time it takes to recover from
          concussion, and ways to prevent concussions is sports.
        </p>
        <p>
          You are being asked to take part in this research study because you
          are a student participating in at least one high-risk concussion sport
          (e.g. ice hockey, rugby, football, soccer, field hockey, basketball,
          volleyball, wrestling, ringette, cheerleading, artistic swimming,
          lacrosse, wheelchair basketball, including ages 8- 18 in community
          sport) or a low-risk sport (competitive swimming). Approximately 6000
          students across the country will be recruited for this study. We will
          follow participants for their high school years.
        </p>
        <h5 className="lead mt-3">
          IF YOU JOIN THE STUDY WHAT WILL HAPPEN TO YOU?
        </h5>
        <ul>
          <li>
            You will be asked to complete a variety of tests when you enter the
            study. These will take approximately 3 hours and will be done at
            school, club, and/or at the University of Calgary. Some tests will
            ask you questions about sport participation, injury history, and
            different aspects of your life. Some tests will be on the computer
            or tablet and some will require you to work with a team member to
            evaluate your balance and neck. Some tests will involve physical
            activity, such as running and jumping.
          </li>
          <li>
            You will be asked to complete a blood test at baseline and during
            mid- season and a robotic assessment.
          </li>
          <li>
            You may be asked to undergo a one-hour MRI session to help us
            determine if MRI can help diagnose concussion
          </li>
          <li>
            If you are not able to undergo an MRI (braces, claustrophobia), you
            may be asked to undergo a 45 min fNIRS & EEG session to help us
            determine if fNIRS can help diagnose concussion
          </li>
          <li>
            You may be asked to wear an Actigraph (wearable technology monitor
            of physical activity and sleep) to be worn around the waist three
            times in a year.
          </li>
          <li>
            You may be asked to have your helmet fit assessed if participating
            in football, ice hockey, ringette, or lacrosse
          </li>
          <li>
            If playing rugby, hockey, ringette and/or football, you may be asked
            to participate in a study where you will be asked to wear a
            mouthguard including wearable technology to measure body impacts.
          </li>
          <li>
            You will be asked to keep track of your participation in sports, and
            you will be asked to report any injuries or concussions you get
            during your participation in the study.
          </li>
          <li>
            You may be invited to participate in interviews or small group
            discussions about concussion knowledge, beliefs, and behaviours
            towards concussion or challenges experienced with returning to
            school following concussion. Information from interviews and groups
            discussions will be used to help develop a concussion education
            program.
          </li>
          <li>
            If you, your parent/guardian or coach thinks you might have a
            concussion, you will be able to see a study physician at the
            University of Calgary or community clinic who specializes in
            concussion to determine if you have a concussion and what you should
            do to recover from it fully before going back to playing sports and
            school.
          </li>
          <li>
            You will also repeat the tests you completed at the beginning of the
            study, along with questionnaires used following concussion and a
            treadmill test. Some participants will be asked to also have their
            blood pressure, heart and breathing rate measured before, after and
            during exercise. This requires wearing a small pressure cuff on your
            finger, some sticky electrodes under your collar bones and abdomen
            and also breathing through a mouthpiece during the test. Some
            participants will receive an Actigraph (wearable technology monitor
            of physical activity) to be worn around the waist following initial
            appointment (within 72 hours) with physician following concussion to
            monitor sleep and levels of physical activity (light-moderate-
            intense). We will also ask you to wear the Actigraph when you return
            to play and 6 months post-injury. These tests will allow us to see
            any changes that happen after a concussion and during recovery.
          </li>
          <li>
            You will ideally keep seeing the physician until you return to
            playing sports.
          </li>
          <li>
            You will be asked to complete blood tests within 72-hours following
            concussion, at 1 week following concussion and then every 2 weeks
            until you have returned to sport.
          </li>
          <li>
            You will be asked to undergo an MRI session within 72-hours
            following a concussion and 30 days following concussion.
          </li>
          <li>
            You may be asked to participate in a small focus group study about
            concussion.
          </li>
          <li>
            Mountain bikers may be asked to participate in an interview to
            assess their experiences of sustaining concussion/mild traumatic
            brain injury and their perceptions of injury prevention and safety
            before and after injury.
          </li>
          <li>
            You may be asked to help us evaluate an injury prevention program
            during the study. This program might evaluate a special training
            program, warm- up, rule change or type of equipment.
          </li>
          <li>If you choose, you may be in the study for up to 3 years.</li>
          <li>
            You may be asked to participate in many of the same measures as
            those with a concussion, even though you do not have a concussion.
          </li>
        </ul>
        <h5 className="lead mt-3">WILL ANY PART OF THIS STUDY HURT?</h5>
        <p>
          The testing done at the start of the season will not hurt. The
          measurements described above will be done under close supervision and
          every effort will be made to ensure your safety. If you have any
          painful areas in your body, please let the testing staff know at the
          start of testing and some of the tests may be modified or left out. As
          with any physical activity, there is the possibility of a muscle
          strain for tests, such as running. You may also experience mild
          discomfort when the tester prepares your skin for electrode placement.
          Some also find breathing through a mouthpiece while exercising
          slightly more difficult than breathing without a mouthpiece. Some of
          the testing may result in dizziness or fatigue in your neck muscles
          for a short time following the tests. If you do have any symptoms at
          any time during testing, please let the tester know and it will be
          stopped.
        </p>
        <p>
          The blood tests will be done following standard laboratory procedures.
          The person taking your blood will be a trained technician. You should
          let the person taking your blood know if you have any allergies.
          Although very rare, there is a possibility of local infection within
          days of having blood taken. There is also a remote possibility of
          fainting. There is a possibility of a slight bruise at the needle
          site.
        </p>
        <p>
          Magnetic resonance imaging (MR) is a technique that uses magnets and
          radio waves, not radiation, to take pictures of the body. MRI has no
          known harmful effects as long as you have none of the risk factors
          that you will be screened for by the MRI technologist. Specifically,
          you should not have an MRI if you have a pacemaker or certain other
          metal objects inside your body (including dental braces), especially
          around the eyes because the strong magnets in the MR scanner might
          cause these to heat up or move, causing harm. You will also need to
          remove all metal from your clothing and pockets; otherwise these
          objects could be pulled into the magnet and cause harm.
        </p>
        <h5 className="lead mt-3">WILL THE STUDY HELP YOU OR OTHERS?</h5>
        <ul>
          <li>
            If you do get a concussion during the study, you will be able to see
            a study physician specializing in concussion within 72-hours.
          </li>
          <li>
            The information we get from this study may help us to provide better
            ways of preventing, diagnosing and managing injuries and concussions
            in youth.
          </li>
        </ul>
        <h5 className="lead mt-3">
          DOES YOUR PARENT/GUARDIAN KNOW ABOUT THIS STUDY?
        </h5>
        <p>
          Yes, your parent/guardian will receive information about this study.
          You can talk this over with them before you decide to participate.
        </p>
        <h5 className="lead mt-3">WHO WILL KNOW WHAT YOU DID IN THE STUDY?</h5>
        <p>
          The information collected about you during this study will be kept
          safe. Nobody will know what you did in the study, except the people
          doing the research. The information about you will not be given to
          your parents/guardians, except for the concussion test results. The
          researchers will not tell your friends or anyone else. The information
          collected about you may be combined and reported with data from other
          studies conducted by this research team. You may be contacted in the
          future and invited to take part in other research studies that are
          like this study, or which look at any injuries you may have. We will
          not share your contact information with anyone outside of the research
          team.
        </p>
        <h5 className="lead mt-3" style={{ fontStyle: "italic" }}>
          Incidental findings
        </h5>
        <p>
          In the unlikely scenario that a researcher observes a suspected
          abnormality in your results (i.e. images, blood tests), an appropriate
          study physician will be consulted and provided with you and your
          parent/guardian information. He or she will make a determination of
          its potential significance to your health and welfare. If considered
          to be a finding of potential clinical significance, your
          parents/guardians will be informed.
        </p>
        <h5 className="lead mt-3">WHAT DO YOU GET FOR BEING IN THE STUDY?</h5>
        <p>
          You do not get any money or gifts for being in this research study. At
          the time of study related visits at the university or clinic, parking
          will be paid for you. In addition, juice and snacks will be available
          to you at the time of blood draw.
        </p>
        <p>
          If you participate in the MRI, SHRED Concussions will supply you with
          a life-size 3-D print of your brain (your choice of color).
        </p>
        <p>
          We will be offering pizza parties, as well as having random draws for
          participants for U of Calgary Dinos, Calgary Hitmen, or other games.
        </p>
        <h5 className="lead mt-3">DO YOU HAVE TO BE IN THE STUDY?</h5>
        <p>
          You don't have to be in the study. No one will be upset if you don't
          want to do this study. If you don't want to be in the study, you just
          have to tell us. It's up to you. You can also take more time to think
          about being in the study and also talk some more with your parent/
          guardian about being in the study. If you start the study and then
          change your mind, you can decide not to take part anymore, just tell
          your parent/guardian and the researcher.
        </p>
        <h5 className="lead mt-3">WHAT IF YOU HAVE ANY QUESTIONS?</h5>
        <p style={{ fontWeight: "bold" }}>
          If you have any questions about the study, please contact or have your
          parents/guardians contact the people organizing the study at
          SHRedConcussions@ucalgary.ca or the primary researcher Carolyn Emery
          at 403-220-4608. If you feel you are being mistreated, you can also
          contact the Chair of the Conjoint Health Research Ethics Board,
          University of Calgary at 403-220-7990.
        </p>
        <hr />
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Participant's Name: <span style={{ color: "red" }}>*</span>
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="child_name"
              name="child_name"
              value={child_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-4 col-form-label">
            Birthdate: <span style={{ color: "red" }}>*</span>
          </label>
          <div className={"col-lg-4 mb-2"}>
            <DatePicker
              id="sessionDate"
              className="form-control"
              name="sessionDate"
              maxDate={new Date()}
              placeholderText="mm/dd/yyyy"
              dropdownMode="select"
              showYearDropdown
              scrollableYearDropdown
              selected={child_dob}
              onChange={this.handleDobChange}
              onChangeRaw={this.handleDobChange}
              autoComplete="off"
            ></DatePicker>
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Email: <span style={{ color: "red" }}>*</span>
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="child_email"
              name="child_email"
              value={child_email}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <br />
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Investigator/Delegate's Name:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="delegate_name"
              name="delegate_name"
              value={delegate_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">Witness' Name:</label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="witness_name"
              name="witness_name"
              value={witness_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <br />
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Parent/Guardian's Name:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="parent_name"
              name="parent_name"
              value={parent_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Parent Email address:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="parent_email"
              name="parent_email"
              value={parent_email}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Parent Phone Number:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="parent_phone_number"
              name="parent_phone_number"
              value={parent_phone_number}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Please check this box if you are willing to be contacted for future
            studies:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <div className="form-check" style={{ marginBottom: "1rem" }}>
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="agree_to_be_contacted"
                  id="agree_to_be_contacted"
                  onClick={this.handleChange}
                />
              </label>
            </div>
          </div>
        </div>
        <hr />
        <p>
          The University of Calgary Conjoint Health Research Ethics Board has
          approved this research study.
        </p>
      </div>
    );
  }
}
